import stripe_top_left from '../../../../assets/images/stripe_top_left.png';
import stripe_down_right from '../../../../assets/images/stripe_down_right.png';
import stripe_middle from '../../../../assets/images/stripe_middle.png';
import explain_acheteur from '../../../../assets/images/logo_acheteurs.png';
import explain_entreprise from '../../../../assets/images/logo_entreprises.png';

export default () => {
  return (
    <div className="home__introLayer" id="IntroLayer">
      <img className="stripe__topleft" src={stripe_top_left} />
      <h1 className="home__introLayerTitle">
        Qu'est-ce que <span className="text-primary">Publiconsult</span> ?
      </h1>
      <p className="home__introLayerSubtitle font-bold text-black font-size-small">
        Publiconsult est une plateforme de consultation nationale en ligne de consultation hors
        marchés
      </p>
      <div className="home__introLayerBox">
        <article className="home__introLayerBoxItem">
          <img src={explain_acheteur} width={92} alt="Acheteur" />
          <div className="home__introLayerBoxItem__contentPub">
            <h2 className="home__introLayerBoxItem__contentPubTitle font-bold text-primary">
              Pour les acheteurs publics
            </h2>
            <ul>
              <li>
                Un moyen simple et rapide pour obtenir 3 devis pour vos achats (travaux,
                fournitures, services)
              </li>
              <li>
                Un annuaire des entreprises inscrites triées par domaines d'activités et secteurs
                géographiques
              </li>
            </ul>
            {/*<Button color={ButtonColor.Transparent}>En savoir plus &gt;</Button>*/}
          </div>
        </article>
        <img className="stripe__middle" src={stripe_middle} />
        <article className="home__introLayerBoxItem">
          <img src={explain_entreprise} width={92} alt="Entreprise" />
          <div className="home__introLayerBoxItem__contentEnt">
            <h2 className="home__introLayerBoxItem__contentEntTitle font-bold text-secondary">
              Pour les entreprises
            </h2>
            <ul>
              <li>
                Un message d'alerte à chaque demande de devis d'un acheteur public proche de vous et
                correspondant à l'activité que vous exercez.
              </li>
              <li>
                Un annuaire des entreprises inscrites triées par domaines d'activités et secteurs
                géographiques
              </li>
            </ul>
            {/*<Button color={ButtonColor.Transparent}>En savoir plus &gt;</Button>*/}
          </div>
        </article>
        <img className="stripe__downright" src={stripe_down_right} />
      </div>
    </div>
  );
};
